import { tabs } from "@/data/content";

export const TabNavigation = ({ activeTab, onChange }) => (
  <nav className="flex gap-2 sm:gap-4 overflow-x-auto pb-2 scrollbar-hide" data-testid="main-navigation">
    {tabs.map((tab) => (
      <button
        key={tab.id}
        onClick={() => onChange(tab.id)}
        className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium whitespace-nowrap transition-all ${
          activeTab === tab.id
            ? "bg-white text-black shadow-lg"
            : "bg-white/5 hover:bg-white/10 border border-white/20"
        }`}
        data-testid={`tab-${tab.id}`}
      >
        {tab.label}
      </button>
    ))}
  </nav>
);
